module.exports = __webpack_public_path__ + "static/media/toycathon.jpg:Zone.6530a930.Identifier";